// extracted by mini-css-extract-plugin
export default {"root":"navy-modal_root__U0bmV","noLongPress":"navy-modal_noLongPress__jvTpR"};